import $ from 'cash-dom';

const ExitPopupEvents = {
	sendEvents(popup, isMobile, triggerType) {
		const name = popup.attr('data-name');
		const vendor = popup.attr('data-vendor') !== undefined
			? popup.attr('data-vendor')
			: popup.find('img').first().attr('alt');
		let action = 'impression';

		if (triggerType) {
			action = `${action} - ${triggerType}`;
		}

		if (typeof GAEvents !== 'undefined') {
			action = `${action} - ${GAEvents.getPageName(window.location.href)}`;

			GAEvents.sendEvent(
				isMobile ? 'Mobile Exit Intent' : 'Exit Intent',
				action,
				vendor,
				true
			);
		}

		if (typeof Alooma !== 'undefined') {
			const aloomaData = Object.assign({}, Alooma.aloomaPageData);

			if (name !== undefined && name !== '') {
				aloomaData.pop_name = name;
			}

			const popupHref = popup.find('#cboxInnerContent').length > 0
				? popup.find('#cboxInnerContent').data('href')
				: '';

			if (popupHref) {
				let vendorId = '';
				const matchLong = popupHref.match(/\/go\/vendor\/([a-z\-0-9]+)\/(\d+)\//);
				if (matchLong?.[2] !== undefined) {
					vendorId = Number(matchLong[2]);
				} else {
					const matchShort = popupHref.match(/\/go\/vendor\/(\d+)\//);
					if (matchShort?.[1] !== undefined) {
						vendorId = Number(matchShort[1]);
					}
				}

				if (vendorId !== '') {
					aloomaData.vendor_id = vendorId;
				}
			}

			if (isMobile && triggerType) {
				aloomaData.trigger_type = triggerType;
			}

			Alooma.applyAloomaTracking();
			Alooma.aloomaSendEvent('exit_intent_fired', aloomaData);
		}

		$(document).trigger('exit-popup-shown');
	}
};

export default ExitPopupEvents;
